export default [
 {
   id: 1,
   slug: "Some-quotes-from-the-fountainhead",
   content: "The question isn't who is going to let me ; it's who is going to stop me.\n\nIf one doesn't respect oneself one can neither have love nor respect for others.\n\nEven hands do perspire when held long.\n\nTo sell your soul is the easiest thing in the world. That's what everybody does every hour of his life.If I asked you to keep your soul -- would you understand why that's much harder.\n\n That's the way with young people -- they make an issue where none exists.\n\nMen differ in their virtues , if any , but they are alike in their vices.\n\nDaintiness is a girl's greatest asset.",
   desc: "The fountainhead is a book written by ayn rand about her philosophy, which goes by the name invidividualism.",
   date: "13th Feb 2021",
   title: "Some quotes from the fountainhead",
   category: "philosophy",
 }
]